import config from 'src/config';
import api from 'src/services/httpService';
import storage from 'src/storage';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${storage.getToken()}`
  }
});

class Broadcast {
  // Queue a broadcast to an audience (all_riders | all_drivers | both)
  static sendBroadcast(data) {
    return api.post(`${config.rootUrl}/admin/broadcast`, data, authConfig());
  }

  // Send a test of the broadcast to the requesting admin only
  static sendTest(data) {
    return api.post(
      `${config.rootUrl}/admin/broadcast/test`,
      data,
      authConfig()
    );
  }

  // Live recipient count for an audience
  static getRecipientCount(audience) {
    return api.get(
      `${config.rootUrl}/admin/broadcast/recipient-count?audience=${audience}`,
      authConfig()
    );
  }

  // Most recent broadcasts (history view — backend caps at 20)
  static getHistory() {
    return api.get(`${config.rootUrl}/admin/broadcasts`, authConfig());
  }
}

export default Broadcast;
